import React, { useState } from "react";
import { CardList } from "@panda0/panda0-ui";
import { FileText } from "lucide-react";

import RadarCharts from "../charts/radarchart";

const Abilities = ({ abilitiesRef, questions }) => {
  const [activeQuestion, setActiveQuestion] = useState(0);

  // Sample radar data for cognitive abilities
  const radarData = [
    { subject: "Create", A: 50, B: 80, fullMark: 100 },
    { subject: "Evaluate", A: 55, B: 83, fullMark: 100 },
    { subject: "Analyze", A: 30, B: 77, fullMark: 100 },
    { subject: "Apply", A: 20, B: 50, fullMark: 100 },
    { subject: "Understand", A: 35, B: 75, fullMark: 100 },
  ];

  // Calculate overall score
  const calculateOverallScore = () => {
    let totalScore = 0;
    let maxScore = 0;

    questions.forEach((question) => {
      // Find the highest possible score for this question
      const maxPossibleScore = Math.max(
        ...question.options.map((opt) => opt.score)
      );
      maxScore += maxPossibleScore;

      // Assume the user selected the option with score 8 (second best) for simplicity
      // In a real app, you'd use the actual user selection
      const selectedScore = 8;
      totalScore += selectedScore;
    });

    return Math.round((totalScore / maxScore) * 100);
  };

  const overallScore = calculateOverallScore();

  // Get cognitive level color
  const getCognitiveColor = (level) => {
    const colors = {
      Understand: "bg-green-100 text-green-800",
      Apply: "bg-yellow-100 text-yellow-800",
      Analyze: "bg-orange-100 text-orange-800",
      Evaluate: "bg-red-100 text-red-800",
      Create: "bg-purple-100 text-purple-800",
    };

    return colors[level] || "bg-gray-100 text-gray-800";
  };

  return (
    <div id="abilities" ref={abilitiesRef} className="pb-10 pt-6 border-t">
      {/* <div className="flex items-center mb-6">
        <div className="h-8 w-8 rounded-full bg-indigo-100 text-indigo-600 flex items-center justify-center mr-3">
          <FileText className="h-4 w-4" />
        </div>
        <h2 className="text-xl font-bold">Cognitive Abilities</h2>
      </div> */}

      {/* Score Overview */}
      {/* <div className="grid grid-cols-1 sm:grid-cols-4 gap-4 mb-8">
        <CardList.Card outerClassName="border rounded-lg shadow-sm p-4 flex flex-col items-center justify-center">
          <div className="text-3xl font-bold text-green-600">
            {overallScore}%
          </div>
          <div className="text-sm text-neutral-500 mt-1">Overall Score</div>
        </CardList.Card>

        <CardList.Card outerClassName="border rounded-lg shadow-sm p-4 flex flex-col items-center justify-center">
          <div className="text-3xl font-bold text-blue-600">
            {questions.length}
          </div>
          <div className="text-sm text-neutral-500 mt-1">Questions</div>
        </CardList.Card>

        <CardList.Card outerClassName="border rounded-lg shadow-sm p-4 flex flex-col items-center justify-center">
          <div className="text-3xl font-bold text-purple-600">28:45</div>
          <div className="text-sm text-neutral-500 mt-1">Time Taken</div>
        </CardList.Card>

        <CardList.Card outerClassName="border rounded-lg shadow-sm p-4 flex flex-col items-center justify-center">
          <div className="text-3xl font-bold text-orange-600">4.5/5</div>
          <div className="text-sm text-neutral-500 mt-1">Difficulty</div>
        </CardList.Card>
      </div> */}

      {/* Radar Chart */}
      <div className="grid grid-cols-1 md:grid-cols-1 gap-6 mb-8">
        <CardList.Card outerClassName="border rounded-lg shadow-sm p-4">
          <div className="flex items-center mb-6">
            <div className="h-8 w-8 rounded-full bg-indigo-100 text-indigo-600 flex items-center justify-center mr-3">
              <FileText className="h-4 w-4" />
            </div>
            <h3 className="font-medium text-base">Cognitive Abilities</h3>
          </div>
          <div className="h-[300px]">
            <RadarCharts data={radarData} />
          </div>
        </CardList.Card>

        {/* <CardList.Card outerClassName="border rounded-lg shadow-sm p-4">
          <h3 className="font-medium text-base mb-3">Skills Breakdown</h3>
          <div className="space-y-4">
            {["Understand", "Apply", "Analyze", "Evaluate", "Create"].map(
              (level, idx) => {
                // Generate random score between 60-95 for demonstration
                const score = Math.floor(Math.random() * 36) + 60;
                const width = `${score}%`;

                return (
                  <div key={idx}>
                    <div className="flex justify-between items-center mb-1">
                      <span className="text-sm font-medium">{level}</span>
                      <span className="text-sm font-medium">{score}%</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2.5">
                      <div
                        className={`h-2.5 rounded-full ${getCognitiveColor(level).split(" ")[0].replace("bg-", "bg-")}`}
                        style={{ width }}
                      ></div>
                    </div>
                  </div>
                );
              }
            )}
          </div>
        </CardList.Card> */}
      </div>
    </div>
  );
};

export default React.memo(Abilities);
